import { FieldTypeApiEnum } from 'submodules/api_middleware';
import {
    EditFieldInterface,
    FilterSize,
    LabelSize,
    Option,
} from 'components/interfaces/GeneralInterface';

export const getCountryFormField = (
    value: string,
    countriesList: Option[],
    size?: FilterSize
): EditFieldInterface => ({
    name: 'address.country_code',
    value,
    label: 'address.country',
    type: FieldTypeApiEnum.SELECT,
    size: size || FilterSize.S20,
    labelSize: LabelSize.TOP,
    required: true,
    values: countriesList,
    placeholder: 'filters.choose',
    triggerAllValidations: true,
});
